export const LANGUAGES = ['한국어', 'en', 'ja'];
export const MAX_MOBILE_WIDTH = 960;
